/* eslint-disable */
import "./searchResultInfo.scss"
import SearchResultInfoModel
	from "./SearchResultInfoModel";
import tourCriteriaJsonHydrator from "@/js/common/Domain/Hydrator/tourCriteriaJson";
import requestService from "@/js/common/Domain/Service/request";
let SearchResultInfo = Backbone.Epoxy.View.extend({
	viewModel: new SearchResultInfoModel(),
	countryTemplate: _.template('<div class="searchResultInfo__country">\n\t<div class="searchResultInfo__title">Куда полететь сейчас: <%=name%> от <%=minPrice.formatNumber()%> руб.</div>\n\t<div class="searchResultInfo__description"><%=dateText%>, <%=nightsText%>,\n\t\t<%if(weather){%>\n\t\t\t<%if(weather.airTemperature){%>\n\t\t\t\t<i class="icon-i16_sun"></i> <%=weather.airTemperature%>\n\t\t\t<%}%>\n\t\t\t<%if(weather.waterTemperature){%>\n\t\t\t\t<i class="icon-i16_water3"></i> <%=weather.waterTemperature%>\n\t\t\t<%}%>\n\t\t<%}%>\n\t</div>\n\t<div class="searchResultInfo__link">\n\t\t<a href="#" class="js-epoxy-show-static-block">Смотреть другие страны</a>\n\t</div>\n</div>\n\n\n\n\n'),
	countriesTemplate: _.template('<div class="searchResultInfo__countries">\n\t<div>\n\t\t<div class="searchResultInfo__title">Куда полететь сейчас:</div>\n\t\t<div class="searchResultInfo__description"><%=dateText%>, <%=nightsText%></div>\n\t</div>\n\t<% _.each(countries, function(item){ %>\n\t<div class="searchResultInfo__block">\n\t\t<div class="searchResultInfo__countryName"><%=item.name%> от&nbsp;<%=item.minPrice.formatNumber()%>&nbsp;руб.</div>\n\t\t<div class="searchResultInfo__description">\n\t\t\t<%if(item.weather){%>\n\t\t\t\t<%if(item.weather.airTemperature){%>\n\t\t\t\t\t<i class="icon-i16_sun"></i> <%=item.weather.airTemperature%>\n\t\t\t\t<%}%>\n\t\t\t\t<%if(item.weather.waterTemperature){%>\n\t\t\t\t\t<i class="icon-i16_water3"></i> <%=item.weather.waterTemperature%>\n\t\t\t\t<%}%>\n\t\t\t<%}%>\n\t\t</div>\n\t</div>\n\t<%}) %>\t\n</div>\n<div class="searchResultInfo__link">\n\t<a href="#" class="js-epoxy-show-static-block">Смотреть другие страны</a>\n</div>\n'),
	bindings: {
		":el": "toggle:show"
	},
	events: {
		"click .js-epoxy-show-static-block": "showStaticBlock"
	},
	initialize: function (options) {
		this.parentView = options.parent;
		this.initModelEvents();
	},
	initModelEvents: function () {
		this.parentView.view.model.on("change:loadingState", $.proxy(this.changeLoadingState, this))
	},
	changeLoadingState: function (model, value) {
		var result = value === 'finished' && this.parentView.view.model.get("filteredHotels").length;
		result ? this.getWeather() : this.viewModel.set({show: false});

	},
	getWeather: function () {
		var self = this,
			tourCriteriaJSON = tourCriteriaJsonHydrator(self.parentView.searchFormView.model.getTourCriteria()),
			data = {
				country: self.getCountriesIdFromFilteredHotels(),
				dateRange: tourCriteriaJSON.checkInDateRange
			};
		requestService({
			url: '/forecasts/countries/daily',
			data: data
		}, {
			success: function (data) {
				if (data.success && data.data && data.data.length) {
					self.updateCountries(data.data)
				} else {
					self.updateCountries()
				}
			},
			error: function () {
				self.updateCountries()
			}
		})
	},
	getCountriesIdFromFilteredHotels: function () {
		var countries = [],
			filteredHotels = this.parentView.view.model.get("filteredHotels");
		this.parentView.searchFormView.model.get("countries").get("model").models.forEach(function (country) {
			var hotels = filteredHotels.where({country: country});
			if (hotels.length) {
				countries.push(country.get('id'));
			}
		});
		return countries;
	},
	updateCountries: function (countriesWeather) {
		var countries = [],
			self = this,
			searchFormCountryModel = this.parentView.searchFormView.model.get("countries").get("model").models,
			filteredHotels = self.parentView.view.model.get("filteredHotels");

		searchFormCountryModel.forEach(function (country) {
			var hotels = filteredHotels.where({country: country});
			if (hotels.length) {
				var dateText = self.parentView.searchFormView.model.get("checkInDateRange").get("view").$date.text(),
					firstChar = dateText[0];

				countries.push({
					name: country.get('name'),
					minPrice: Math.floor(Math.min.apply(null,
						_.map(hotels, function (item) {
							return item.get('minPrice')
						}))),
					dateText: dateText.replace(firstChar, firstChar.toUpperCase()),
					nightsText: self.parentView.searchFormView.model.get("nightRange").get("view").$numOfNights.text(),
					weather: findWeather(countriesWeather, country.get('id'))
				});
			}
		});
		if (countries.length === 1) {
			self.$el.find('.js-epoxy-countries-html').html(this.countryTemplate(countries[0]));
		} else if (countries.length > 1) {
			self.$el.find('.js-epoxy-countries-html').html(this.countriesTemplate({
				countries: countries,
				dateText: countries[0].dateText,
				nightsText: countries[0].nightsText
			}));
		}
		self.viewModel.set({
			show: self.parentView.view.model.get("loadingState") === 'finished'
		});

		function findWeather(countriesWeather, countryId) {
			var result;
			if (countriesWeather) {
				for (var i in countriesWeather) {
					if (countriesWeather[i].country.id === countryId) {
						result = {
							airTemperature: createTemperatureStr(countriesWeather[i].airTemperature),
							waterTemperature: createTemperatureStr(countriesWeather[i].waterTemperature),
						};
						break;
					}
				}
			}
			return result;

			function createTemperatureStr(temp) {
				var str = '';
				if (!_.isNull(temp)) {
					temp = +temp;
					if (temp > 0) {
						str += "+"
					} else if (temp < 0) {
						str += "-"
					}
					str += temp + "°";
				}
				return str
			}

		}

	},
	showStaticBlock: function (e) {
		e.preventDefault();
		$(".hot-static").length ? this.parentView.view.model.set({
			beforeToursLoading: true
		}) : window.location.href = '/tury'
	}
});
export default SearchResultInfo